export class NoSchemaError extends Error {
  constructor(endpoint: string) {
    super(
      `Schema could not be fetched.\nPlease check if the endpoint '${
        endpoint
      }' is a valid GraphQL Endpoint.`,
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Playground/util/NoSchemaError.ts